(ns frontend.view.grid.surveys-grid.sub
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::downloading?
 (fn [db _]
   (get db ::downloading?)))
